import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import ProductDetailTemplate from "../components/product/ProductDetailTemplate";
import { productDetails } from "../data/productDetailsData";

export default function ProductDetailPage({ productKey }) {
  const location = useLocation();

  const resolvedKey = useMemo(() => {
    if (productKey) return productKey;
    return location.pathname.replace(/^\//, "");
  }, [location.pathname, productKey]);

  const product = productDetails[resolvedKey];

  if (!product) {
    return <Navigate to="/" replace />;
  }

  return <ProductDetailTemplate product={product} />;
}
